import React from 'react';
import { Pill, PillDot } from '../ui';

// Correspondance sévérité → ton sémantique du design system, partagée par
// toutes les pages Sécurité pour que la même sévérité ait toujours la même
// couleur : critique en rouge, haute en ambre, moyenne en bleu accent.
export const SEVERITY_TONE = {
    Critical: 'danger',
    High: 'warn',
    Medium: 'accent',
    Low: 'neutral',
    Unknown: 'neutral',
};

export const SEVERITY_ORDER = ['Critical', 'High', 'Medium', 'Low', 'Unknown'];

// Couleurs brutes pour la barre de répartition, qui ne peut pas utiliser un Pill
export const SEVERITY_THEME_KEY = {
    Critical: 'danger',
    High: 'warn',
    Medium: 'accent',
    Low: 'ok',
    Unknown: 'text3',
};

export function SeverityPill({ severity }) {
    return (
        <Pill $tone={SEVERITY_TONE[severity] || 'neutral'}>
            <PillDot />
            {severity || 'Unknown'}
        </Pill>
    );
}

// EPSS = probabilité d'exploitation dans les 30 jours. Affiché en pourcentage :
// « 29 % » se lit mieux que « 0.29234 » dans un tableau.
export function formatEpss(value) {
    if (value === null || value === undefined) return '—';
    return `${(value * 100).toFixed(value < 0.01 ? 2 : 1)} %`;
}

export function formatDate(value) {
    if (!value) return '—';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('fr-FR');
}
